import type { SVGProps } from 'react'
const SvgSyEye = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M2.455 11.116C3.531 9.234 6.555 5 12 5c5.444 0 8.469 4.234 9.544 6.116.221.387.331.58.32.868-.013.288-.143.476-.402.852C20.182 14.694 16.706 19 12 19s-8.182-4.306-9.462-6.164c-.26-.376-.39-.564-.401-.852s.098-.482.318-.868M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
			clipRule="evenodd"
		/>
		<path d="M12 4.4c-5.755 0-8.94 4.452-10.064 6.418-.221.386-.418.74-.399 1.192.02.456.249.79.508 1.166C3.367 15.094 6.928 19.6 12 19.6s8.633-4.506 9.955-6.424c.26-.377.489-.71.508-1.166v-.002c.019-.452-.176-.804-.397-1.19C20.943 8.852 17.756 4.4 12 4.4m0 1.2c5.133 0 7.996 4.016 9.023 5.814.221.386.246.421.24.545-.004.12-.035.16-.294.537C19.73 14.292 16.34 18.4 12 18.4s-7.73-4.108-8.969-5.904c-.26-.376-.29-.418-.295-.537-.005-.124.02-.159.24-.545C4.005 9.616 6.867 5.6 12 5.6" />
		<path d="M12 8.4c-1.981 0-3.6 1.619-3.6 3.6s1.619 3.6 3.6 3.6 3.6-1.619 3.6-3.6-1.62-3.6-3.6-3.6m0 1.2c1.333 0 2.4 1.067 2.4 2.4s-1.067 2.4-2.4 2.4-2.4-1.067-2.4-2.4 1.067-2.4 2.4-2.4" />
	</svg>
)
export default SvgSyEye
